import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const KEY = "menuone_ads_consent";
export const getAdsConsent = () => localStorage.getItem(KEY);

export const AdsConsentBanner = ({ onChange }) => {
  const [visible, setVisible] = useState(false);
  useEffect(() => { setVisible(!getAdsConsent()); }, []);
  const decide = (v) => { localStorage.setItem(KEY, v); setVisible(false); onChange?.(v); };
  if (!visible) return null;
  return (
    <div className="fixed inset-x-3 bottom-3 z-50 rounded-2xl bg-gray-950 text-white p-4 shadow-2xl max-w-lg mx-auto" data-testid="ads-consent-banner">
      <p className="text-sm leading-relaxed">
        Questo menù gratuito è sostenuto da annunci Google. Con il tuo consenso Google può usare cookie per mostrarti pubblicità personalizzata.{" "}
        <Link to="/privacy" className="underline text-[#8fd39c]" data-testid="ads-consent-privacy">Informativa</Link>
      </p>
      <div className="flex gap-2 mt-3">
        <button onClick={() => decide("granted")} className="flex-1 h-10 rounded-full bg-[#5aa469] font-semibold text-sm active:scale-95 transition-transform" data-testid="ads-consent-accept">Accetta</button>
        <button onClick={() => decide("denied")} className="flex-1 h-10 rounded-full bg-white/10 font-semibold text-sm active:scale-95 transition-transform" data-testid="ads-consent-deny">Solo annunci non personalizzati</button>
      </div>
    </div>
  );
};
